import { throttle } from 'throttle-debounce';
import { SETTINGS } from '../utils/constants';

const initScrollToTop = () => {
  const buttonEl = document.querySelector('[data-scroll-top]');
  if (!buttonEl || buttonEl.dataset.scrollTopInit) return;
  buttonEl.dataset.scrollTopInit = 'true';

  const toggleVisibility = () => {
    const isPastThreshold = window.scrollY > window.innerHeight;
    buttonEl.classList.toggle('hidden', !isPastThreshold);
  };

  buttonEl.addEventListener('click', () => {
    const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: hasReducedMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', throttle(SETTINGS.THROTTLE_DELAY_SMALL, toggleVisibility));
  toggleVisibility();
};

export default initScrollToTop;
